/**
 * The lead forms' email field copy. Back to plain "Email" (Thomas, Oct 5 2026)
 * after visitors quit the quote card at this box. History: it was "Email"
 * until #85 data showed 62% of phone leads arriving with Gmail, Yahoo and the
 * like, and "Work email" from #215 (Sep 30). Watch the personal-address share
 * and bcecloud's personal-email hold (#755) after this change. The hint under
 * the field ("We'll send your proposal here.") was removed to shorten the form
 * (Thomas, Oct 22 2026).
 */
export const EMAIL_LABEL = 'Email';

/**
 * The one email rule, used by the form's check and the server's schema alike so
 * the form never refuses what the server would take, or the reverse. As wide
 * as Salesforce's Email field allows (any RFC 5322 "atext" character before
 * the @, ASCII host labels and a letter TLD after it), and no wider, since a
 * value Salesforce rejects would lose the lead downstream. No leading, trailing
 * or doubled dots before the @. Values are cleaned first (field-clean.ts).
 */
export const LEAD_EMAIL_RE =
  /^(?!\.)(?!.*\.\.)[A-Za-z0-9!#$%&'*+/=?^_`{|}~.-]+(?<!\.)@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
